import { ILangObj } from '@/slices/goyoloSeo/sliceType';
import { style } from '@/styles/globals';
import React from 'react';
import { noDataDescriptionVi } from '../../utils/constants';
import { useAppSelector } from '../../utils/hook';

const ShowNoDataDescription = ({ lang }: { lang?: ILangObj }) => {
  const { startPoint, startPointHome } = useAppSelector((app) => app.searchFlightForm);
  if (!startPoint && !startPointHome) {
    return (
      <div style={{ color: style.color.orange2 }}>
        {lang?.global?.chooseDestination?.[0] || 'Bạn vui lòng'}
        {' '}
        <b>{lang?.global?.chooseDestination?.[1] || 'chọn nơi đi'}</b>
        {' '}
        {lang?.global?.chooseDestination?.[2] || 'ở trên để xem giá rẻ nhất'}
      </div>
    );
  }
  return <div>{lang?.global?.noDataDescriptionVex || noDataDescriptionVi}</div>;
};

export default ShowNoDataDescription;
